import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class UsersService {

  constructor(
    private http: Http
  ) { }

  getAll() {
    return this.http
      .get(`${environment.apiUrl}/admin/users`)
      .map(this.extractData);
  }

  delete(userId: number): Observable<Response> {
    return this.http.delete(`${environment.apiUrl}/admin/users/${userId}`).catch(this.handleError);
  }

  save(user) {
    user.name = `${user.first_name} ${user.last_name}`;
    user.is_group_admin = 0;
    return this.http
      .post(`${environment.apiUrl}/admin/users`, user)
      .map(this.extractData)
      .catch(this.handleError);
  }

  update(user) {
    const tempUser = Object.assign({}, user);
    tempUser['_method'] = 'put';
    tempUser.group_id = tempUser.group.id;
    delete tempUser.group;
    // Make sure we don't send up an empty string as the password
    if (tempUser.password === '') {
      delete tempUser.password;
    }

    return this.http
      .post(`${environment.apiUrl}/admin/users/${tempUser.id}`, tempUser);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || [];
  }

  private handleError (error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/users.service.ts